import dayjs from "dayjs";
import { DateSeparatorProps } from "stream-chat-react";

export const DateSeparator = (props: DateSeparatorProps) => {
  const { date } = props;

  return (
    <div className="t-flex t-items-center t-justify-center t-my-6" {...props}>
      <div className="t-max-w-[120px] t-flex-1 t-h-[1px] t-mr-2 t-bg-separator-fade-left"></div>
      <span className="t-text-body-sm t-text-text-30 t-w-min-fit">
        {dayjs(date).format("MMM DD, YYYY")}
      </span>
      <div className="t-ml-2 t-max-w-[120px] t-flex-1 t-h-[1px] t-bg-separator-fade-right"></div>
    </div>
  );
};
